import './Logo.scss';

import MbaLogoImg from 'assets/images/mba-logo.png';
import Image from 'components/partials/elements/components/image/Image';
import LazyLoadImage from 'components/partials/lazy-load/components/lazy-load-image/LazyLoadImage';
import React from 'react';
import { Link } from 'react-router-dom';

const Logo = () => {
  return (
    <Link to="/" className="primary-logo">
      <LazyLoadImage>
        <Image
          width="100%"
          height="100%"
          src={MbaLogoImg}
          title="Military Benefit Association"
          alt="Military Benefit Association"
          className="primary-logo-img"
        />
      </LazyLoadImage>
    </Link>
  );
};

export default Logo;
